export default __webpack_public_path__ + "static/prevention-2751984759b59dc41e788c4ac05410ce.jpg";